import style from "../style/registration.module.scss";
import {CounselorDuplicateCheckButtonFiled} from "./CounselorDuplicateCheckButtonFiled";
import {CounselorInfoAddressField} from "./CounselorInfoAddressField";
import {CounselorShortTextField} from "./CounselorShortTextField";
import {CounselorCheckboxField} from "./CounselorCheckboxField";
import {CounselorPriceField} from "../CounselorPriceField";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {CounselorCheckOptions, CounselorDuplicateType, TaxSelectedValue,} from "../../../types/counselor";
import {CounselorRadioField} from "./CounselorRadioField";
import {Label104x46} from "../../../components/Label";
import {CounselorLongInputField} from "./CounselorLongInputField";
import {CounselorShortNumberField} from "./CounselorShortNumberField";
import {useCounselorStore} from "./hooks/counselorStore";

export function CounselorGroupField() {
    /**
     * 상담 소속정보 영역
     */
    const {t} = useTranslation("counselorGroup");
    const {groupDTO, setGroupDTO, validates, setValidate} = useCounselorStore();

    const [isVatInclude, setIsVatInclude]
        = useState(groupDTO.isVatInclude ? TaxSelectedValue.SELECT : TaxSelectedValue.UNSELECT);
    const [isTaxDeducted, setIsTaxDeducted]
        = useState(groupDTO.isTaxDeduction ? TaxSelectedValue.SELECT : TaxSelectedValue.UNSELECT);


    useEffect(() => {
        if (setGroupDTO) {
            setGroupDTO({
                ...groupDTO,
                isVatInclude: isVatInclude === TaxSelectedValue.SELECT,
                isTaxDeduction: isTaxDeducted === TaxSelectedValue.SELECT,
            });
        }
        //eslint-disable-next-line
    }, [isVatInclude, isTaxDeducted]);


    return (
        <>
            {/*  상담 소속이름  */}
            <CounselorDuplicateCheckButtonFiled
                duplicateType={CounselorDuplicateType.GROUP_NAME}
                minLength={2} maxLength={50}
                label={t('registration.group.name')}
                placeHolder={t('registration.groupPlaceHolder')}
                isLabelVisible={true}
                value={groupDTO.name}
                setValue={(value) => setGroupDTO({...groupDTO, name: value})}
                validate={validates.groupName}
                setValidate={(status) => setValidate('groupName', status)}
            />

            {/*  상담 소속주소  */}
            <CounselorInfoAddressField
                value={groupDTO.address}
                setValue={(value) => setGroupDTO({...groupDTO, address: value})}
                validate={validates.address}
                setValidate={(status) => setValidate('address', status)}
            />

            {/*  전화번호  */}
            <CounselorShortNumberField
                label={t('registration.group.cellPhone')}
                placeHolder={t('registration.cellPhonePlaceHolder')}
                minLength={0} maxLength={11}
                isRequired={false}
                isLabelVisible={true}
                value={groupDTO.phoneNumber}
                setValue={(value) => setGroupDTO({...groupDTO, phoneNumber: value})}
            />

            {/*  상담 소속약력  */}
            <CounselorLongInputField
                label={t('registration.group.counselorProfile')}
                isRequired={false}
                placeHolder={t('registration.profilePhonePlaceHolder')}
                value={groupDTO.briefHistory}
                setValue={(value) => setGroupDTO({...groupDTO, briefHistory: value})}
            />

            {/*  소속 계좌정보  */}
            <CounselorCheckboxField
                label={t("registration.group.accountInfo")}
                isRequired={false}
                placeHolder={t('registration.accountPlaceHolder')}
                additionalText={"정산 받으실 은행을 선택해주세요."}
                checkboxOption={CounselorCheckOptions.ACCOUNT}
                option={groupDTO.bankName}
                setOption={(value) => setGroupDTO({...groupDTO, bankName: value})}
            >
                <div className={style.childrenWrapper}>
                    <CounselorShortNumberField
                        label={''}
                        placeHolder={(t('registration.accountNumberPlaceHolder'))}
                        minLength={7} maxLength={20}
                        isRequired={true}
                        isLabelVisible={false}
                        value={groupDTO.accountNumber}
                        setValue={(value) => setGroupDTO({...groupDTO, accountNumber: value})}
                    />
                    <CounselorShortTextField
                        label={''}
                        placeHolder={(t('registration.accountNamePlaceHolder'))}
                        inputType={'text'}
                        minLength={2} maxLength={50}
                        isRequired={true}
                        isLabelVisible={false}
                        value={groupDTO.accountName}
                        setValue={(value) => setGroupDTO({...groupDTO, accountName: value})}
                    />
                </div>
            </CounselorCheckboxField>

            {/*  소속 분배금 & 상담사 분배금  */}
            <div className={style.priceMainWrapper}>
                {/*  소속 분배금  */}
                <div className={style.priceInputWrapper}>
                    <Label104x46 text={t("registration.group.groupDistribution")} isRequired={true}/>
                    <CounselorPriceField
                        value={groupDTO.affiliationDistributionAmount}
                        setValue={(value) => setGroupDTO({...groupDTO, affiliationDistributionAmount: value})}
                        validate={validates.affiliationDistribution}
                        setValidate={(status) => setValidate('affiliationDistribution', status)}
                    />
                </div>

                {/*  상담사 분배금  */}
                <div className={style.priceInputWrapper}>
                    <Label104x46 text={t("registration.group.counselorDistribution")} isRequired={true}/>
                    <CounselorPriceField
                        value={groupDTO.consultantDistributionAmount}
                        setValue={(value) => setGroupDTO({...groupDTO, consultantDistributionAmount: value})}
                        validate={validates.consultantDistribution}
                        setValidate={(status) => setValidate('consultantDistribution', status)}
                    />
                </div>
            </div>

            {/*  부가세 / 세금공제  */}
            <div className={style.taxInputWrapper}>
                <div className={style.taxArea}>
                    <Label104x46 text={t("registration.group.addedTax")} isRequired={false}/>
                    <CounselorRadioField
                        selectedValue={isVatInclude}
                        setSelectedValue={(v) => setIsVatInclude(v)}
                        groupName={"groupTaxAdded"}
                    />
                </div>

                <div className={style.taxArea}>
                    <Label104x46 text={t("registration.group.taxDeduction")} isRequired={false}/>
                    <CounselorRadioField
                        selectedValue={isTaxDeducted}
                        setSelectedValue={(v) => setIsTaxDeducted(v)}
                        groupName={"groupTaxDeduction"}
                    />
                </div>
            </div>
        </>
    );
}